import { FlightEventHandler } from "./flight"
import maxRssi from "../utils/maxRssi"
import * as L from 'leaflet'
import * as map from '../map'
import GrsDevices from "./grsDevices"
import PrimaryLink from './primaryLink'

export default class SignalLines extends FlightEventHandler {
	grsMapLines = {}
	ownshipLine = null
	primaryLink = null
	devices = {}
	
	devicesUnsubscribe = null
	linkUnsubscribe = null
	grsDevicesHandler = null
	primaryLinkHandler = null

	constructor(flight) {
		super(flight)

	}

	handleRegistered() {
		this.lineLayer = L.layerGroup()
		this.lineLayer.addTo(map.getMap())
		this.overlay = map.addOverlay("Signal Lines", this.lineLayer, this.flight.overlay)

		this.mapZoom = this.mapZoom.bind(this)
		map.getMap().on('zoomend', this.mapZoom)

		this.grsDevicesHandler = this.flight.getHandler(GrsDevices)
		this.primaryLinkHandler = this.flight.getHandler(PrimaryLink)

		this.devicesUnsubscribe = this.grsDevicesHandler.store.subscribe(this.deviceUpdate.bind(this))
		this.linkUnsubscribe = this.primaryLinkHandler.subscribe(this.primaryLinkUpdate.bind(this))
	}

	mapZoom() {
		this.deviceUpdate(this.devices)
	}

	primaryLinkUpdate(primaryLink) {
		this.primaryLink = primaryLink.local
		this.deviceUpdate(this.devices)
	}

	deviceUpdate(devices) {
		this.devices = devices
		for (const id in devices) {
			this.updateLine(devices[id], this.grsMapLines[id])
		}
		for (const id in this.grsMapLines) {
			if (!devices[id]) this.clearLine(this.grsMapLines[id])
		}
	}

	clearLine(line) {
		line.removeFrom(this.lineLayer)
	}

	updateLine(device, line) {
		if (!device || !device.lastStatus) return
		if (device.type !== 'GRS') return

		let rssi = maxRssi(device.lastStatus.local)
		let color
		let arsLoc = device.lastArsLocation

		if (!arsLoc) return

		if (device.lastStatus.remote.protocol.radioStatus === 0 || 
				device.lastStatus.remote.position.latitude === 0) {
			
			rssi = 0
			color = "#999999"
		} else if (rssi > -80) {
			color = "#00cc00"
		} else if (rssi < -100) {
			color = "#cc0000"
		} else {
			color = "#cccc00"
		}
		if (device.linkId !== this.primaryLink) {
			color = "#bbbbbb"
			// rssi = 0
		}

		const latLngs = [
			[device.latitude, device.longitude],
			arsLoc,
		]
		if (!line) {
			line = L.polyline(latLngs, {
				className: 'radioLine',
				color
			}).addTo(this.lineLayer)
			line.bindTooltip('0.000', {
				permanent: true,
				offset: [0, 0],
				className: "lineLabel",
				direction: "center"
			}, this.lineLayer)
			// line.openTooltip()
			this.grsMapLines[device.id] = line
		}

		line.setLatLngs(latLngs)
		line.setStyle({ color })
		if (rssi)  {
			line.setTooltipContent(rssi.toString())
			line.openTooltip()
		} else {
			line.setTooltipContent('')
			line.closeTooltip()	
		}

		if (device.isLead) {

			const m = map.getMap()
			// Draw the ARS receive line
			const grsPt = m.latLngToLayerPoint(latLngs[0])
			const arsPt = m.latLngToLayerPoint(latLngs[1])
			const shiftAmount = 5
			const vec = [arsPt.x - grsPt.x, arsPt.y - grsPt.y]
			const direction = Math.atan2(vec[1], vec[0]) + Math.PI / 2
			const shiftX = Math.cos(direction) * shiftAmount
			const shiftY = Math.sin(direction) * shiftAmount
			const latLon = [m.layerPointToLatLng([grsPt.x + shiftX, grsPt.y + shiftY]), m.layerPointToLatLng([arsPt.x + shiftX, arsPt.y + shiftY])]

			if (!this.ownshipLine) {
				this.ownshipLine = L.polyline(latLon, {
					color: "blue",
					className: "radioLine arsRadioLine"
				})
				this.ownshipLine.addTo(this.lineLayer)
			} else {
				this.ownshipLine.setLatLngs(latLon)
			}
		}
	}

	clearLines() {
		if (this.ownshipLine) this.ownshipLine.removeFrom(this.lineLayer)
		for (const deviceId in this.grsMapLines) {
			this.grsMapLines[deviceId].removeFrom(this.lineLayer)
		}
		this.ownshipLine = null
		this.grsMapLines = {}

		this.flight.releaseHandler(GrsDevices)
		this.flight.releaseHandler(PrimaryLink)

		this.devicesUnsubscribe?.()
		this.linkUnsubscribe?.()
	}

	cleanup() {
		super.cleanup()
		this.clearLines()
		if (this.lineLayer) {
			this.lineLayer.removeFrom(map.getMap())
			map.removeOverlay(this.overlay)
		}
		map.getMap().off('zoomend', this.mapZoom)
	}
}
